import React, { FC } from 'react';
import { useRouter } from 'next/router';
import useTranslation from '@hooks/useTranslation';
import ButtonTemplate from '@ui/Button/Button';
import Cookies from 'js-cookie';
import { ACCESS_TOKEN_KEY_GUEST, REFRESH_TOKEN_KEY_GUEST, ROUTES } from '../../constants';
import ContentWrapper from '../../ui/Content/Content';
import { Message, Wrapper } from './InaccessibleErrorForGuest.elements';

interface InaccessibleErrorForGuestProps {}

const InaccessibleErrorForGuestTemplate: FC<InaccessibleErrorForGuestProps> = () => {
    const { t } = useTranslation();

    const router = useRouter();

    return (
        <ContentWrapper>
            <Wrapper>
                <Message>{t('guest.error.noAccessible.message')}</Message>
                <ButtonTemplate
                    text={t('guest.error.noAccessible.button')}
                    onClick={() => {
                        Cookies.remove(ACCESS_TOKEN_KEY_GUEST);
                        Cookies.remove(REFRESH_TOKEN_KEY_GUEST);
                        router.push({ pathname: ROUTES.HOME });
                    }}
                />
            </Wrapper>
        </ContentWrapper>
    );
};
export default InaccessibleErrorForGuestTemplate;
